import { Directionality } from "@angular/cdk/bidi";
import { Platform } from "@angular/cdk/platform";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Optional, Output, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { InputBoolean, InputNumber } from "ng-zorro-antd/core/util";

import { UiSliderHandleComponent } from "./components/handle/handle.component";
import { UiSliderService } from "./services/slider.service";
import { NzSliderComponent } from "ng-zorro-antd/slider";
import { UiMarks, UiSliderShowTooltip, UiSliderValue } from "./models/slider.models";

@Component({
  selector: "ui-slider",
  exportAs: "uiSlider",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiSliderComponent),
      multi: true,
    },
    UiSliderService,
  ],
  templateUrl: "slider.component.html",
})
export class UiSliderComponent extends NzSliderComponent {
  @Input("uiDisabled")
  @InputBoolean()
  public nzDisabled = false;
  @Input("uiDots")
  @InputBoolean()
  public nzDots = false;
  @Input("uiIncluded")
  @InputBoolean()
  public nzIncluded = true;
  @Input("uiRange")
  @InputBoolean()
  public nzRange = false;
  @Input("uiVertical")
  @InputBoolean()
  public nzVertical = false;
  @Input("uiReverse")
  @InputBoolean()
  public nzReverse = false;
  @Input("uiDefaultValue")
  public nzDefaultValue?: UiSliderValue;
  @Input("uiMarks")
  public nzMarks: UiMarks | null = null;
  @Input("uiMax")
  @InputNumber()
  public nzMax = 100;
  @Input("uiMin")
  @InputNumber()
  public nzMin = 0;
  @Input("uiStep")
  @InputNumber()
  public nzStep = 1;
  @Input("uiTooltipVisible")
  public nzTooltipVisible: UiSliderShowTooltip = "default";
  @Input("uiTooltipPlacement")
  public nzTooltipPlacement = "top";
  @Input("uiTipFormatter")
  public nzTipFormatter?: null | ((value: number) => string);

  @Output("uiOnAfterChange")
  public readonly nzOnAfterChange = new EventEmitter<UiSliderValue>();

  @ViewChild("slider", { static: true })
  public slider!: ElementRef<HTMLDivElement>;
  @ViewChildren(UiSliderHandleComponent)
  public handlerComponents!: QueryList<UiSliderHandleComponent>;

  constructor(sliderService: UiSliderService, cdr: ChangeDetectorRef, platform: Platform, @Optional() directionality: Directionality) {
    super(sliderService, cdr, platform, directionality);
  }
}
